/* CW: section palette, partners under The Fit, faster reveals, marker cleanup. */
(function () {
  var CDN = 'https://cdn.shopify.com/s/files/1/0751/5186/8100/files/';
  var ROMAN = ['I','II','III','IV','V','VI','VII','VIII','IX','X','XI','XII'];

  var PEOPLE = [
    { n: 'Jed Collins',      f: 'jed-portrait-2.jpg?v=1785213960' },
    { n: 'Lewis Hamilton',   f: '240102-lewis-hamilton-mb-1209-65adb6.jpg?v=1785249385' },
    { n: 'Jordan Palmer',    f: 'jordan-palmer.jpg?v=1785213861' },
    { n: 'Mary Lawless Lee', f: 'mary_lawless_nemah.jpg?v=1785249384' },
    { n: 'Mark Rober',       f: 'mark-rober.jpg?v=1785213862' },
    { n: 'MrBeast',          f: 'mr_beast.jpg?v=1785213861' },
    { n: 'Paris Hilton',     f: 'paris_hilton.webp?v=1785213861' }
  ];
  var COMPANIES = [
    { n: 'Bumpsuit',           f: 'bumpsuit_logo.webp?v=1785213861' },
    { n: 'Nemah',              f: 'nemah.webp?v=1785249385' },
    { n: 'Los Reyes',          f: 'losreyes-cheetah.jpg?v=1785213921' },
    { n: 'Happily Grey',       f: 'happily_grey.png?v=1785249385' },
    { n: 'Thread Performance', f: 'thread-performance.webp?v=1785213861' },
    { n: 'CrunchLabs',         f: 'crunchlabs_box.webp?v=1785213861' },
    { n: 'Nuhr Home',          f: 'nuhr-home.webp?v=1785215217' },
    { n: 'Saint Candles',      f: 'saintcandles.webp?v=1785215217' },
    { n: 'The Space Race',     f: 'the_space_race.jpg?v=1785213861' }
  ];

  function fasterReveals() {
    var st = document.createElement('style');
    st.textContent =
      '.reveal{transform:translateY(10px);' +
      'transition:opacity .4s cubic-bezier(.16,1,.3,1),transform .4s cubic-bezier(.16,1,.3,1)}';
    document.head.appendChild(st);
    var io = new IntersectionObserver(function (es) {
      for (var i = 0; i < es.length; i++) {
        if (es[i].isIntersecting) { es[i].target.classList.add('in'); io.unobserve(es[i].target); }
      }
    }, { threshold: 0, rootMargin: '0px 0px 15% 0px' });
    var els = document.querySelectorAll('.reveal');
    for (var i = 0; i < els.length; i++) io.observe(els[i]);
  }

  function card(it) {
    return '<a class="partner-card">' +
      '<div class="partner-tile cw-has-img cw-cover">' +
      '<img decoding="async" fetchpriority="low" alt="' + it.n + '" src="' + CDN + it.f + '&width=460">' +
      '<span>' + it.n + '</span></div>' +
      '<div class="partner-meta"><div class="tg">' + it.n + '</div></div></a>';
  }

  function fill(track, list) {
    var html = list.map(card).join('');
    track.innerHTML = html + html;
  }

  function el(cn, text) {
    var d = document.createElement('div');
    d.className = cn; d.textContent = text; return d;
  }

  /* Markers and the right-hand rail carry hardcoded numerals, so moving a
     section makes them wrong. Rebuild both from real DOM order, and drop the
     dated location note on the right of the strips. */
  function renumber() {
    var markers = [].slice.call(document.querySelectorAll('.chapter-marker'));
    var titles = [];
    markers.forEach(function (m, i) {
      var pink = m.querySelector('.pink');
      if (pink) pink.textContent = 'Chapter ' + (ROMAN[i] || i + 1);

      var right = m.children[1];
      if (right && /NYC|Remote|20\d\d/i.test(right.textContent)) right.remove();

      var first = m.children[0];
      var t = first ? first.textContent : '';
      var bits = t.split('·');
      titles.push((bits.length > 1 ? bits.slice(1).join('·') : t).trim());
    });

    var meter = document.getElementById('meter');
    if (!meter) return;
    var html = '<div><b></b><span>·</span> Hero</div>';
    titles.forEach(function (t, i) {
      html += '<div><b></b><span>' + (ROMAN[i] || i + 1) + '</span> ' + t + '</div>';
    });
    meter.innerHTML = html;
  }

  function boot() {
    fasterReveals();

    var problem = document.querySelector('section.problem');
    if (problem && !problem.classList.contains('cw-sand')) {
      problem.classList.add('cw-sand');
      problem.removeAttribute('data-bg');
    }

    var thesis = document.querySelector('section.thesis');
    var fitSec = document.querySelector('section.fit');
    if (thesis && fitSec && !document.querySelector('.cw-ink-band')) {
      var start = thesis.previousElementSibling;
      if (!start || !start.classList.contains('chapter-marker')) start = thesis;
      var band = document.createElement('div');
      band.className = 'cw-ink-band';
      band.setAttribute('data-bg', 'ink');
      start.parentNode.insertBefore(band, start);
      var node = start, next;
      while (node) {
        next = node.nextElementSibling;
        band.appendChild(node);
        if (node === fitSec) break;
        node = next;
      }
    }

    var partners = document.querySelector('section.partners');
    if (partners && fitSec && partners.previousElementSibling !== fitSec) {
      var pMarker = partners.previousElementSibling;
      var anchor = fitSec;
      if (pMarker && pMarker.classList.contains('chapter-marker')) {
        fitSec.parentNode.insertBefore(pMarker, fitSec.nextSibling);
        anchor = pMarker;
      }
      anchor.parentNode.insertBefore(partners, anchor.nextSibling);
    }

    var row1 = partners && partners.querySelector('.marquee');
    if (row1 && !document.querySelector('.marquee.cw-row-2')) {
      fill(row1.querySelector('.marquee-track'), PEOPLE);
      row1.parentNode.insertBefore(el('cw-row-label', 'The people'), row1);

      var l2 = el('cw-row-label', 'The companies');
      row1.parentNode.insertBefore(l2, row1.nextSibling);

      var row2 = row1.cloneNode(true);
      row2.classList.add('cw-row-2');
      fill(row2.querySelector('.marquee-track'), COMPANIES);
      l2.parentNode.insertBefore(row2, l2.nextSibling);

      row2.parentNode.insertBefore(
        el('cw-row-note', 'Store builds, operations, and partnerships across our team’s work.'),
        row2.nextSibling
      );

      [].forEach.call(document.querySelectorAll('.marquee-track'), function (t) {
        t.removeAttribute('id');
      });
    }

    renumber();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
